import React, { useEffect, useState } from 'react'
import Modal from '../Common/Modal'
import userService from '../../services/userService'

const sanitizePhone = (value = '') => {
  const trimmed = value.trim()
  if (!trimmed) return ''
  const digits = trimmed.replace(/[^+\d]/g, '')
  if (!digits) return ''
  return digits.startsWith('+') ? digits : `+${digits}`
}

const PhoneVerificationModal = ({ isOpen, onClose, onVerified, initialPhoneNumber }) => {
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber || '')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isOpen) {
      setPhoneNumber(initialPhoneNumber || '')
      setError('')
    }
  }, [isOpen, initialPhoneNumber])

  if (!isOpen) return null

  const handleSave = async (event) => {
    event?.preventDefault()
    setSaving(true)
    setError('')
    try {
      const user = userService.getCurrentUser()
      if (!user) throw new Error('Not authenticated')

      const normalized = sanitizePhone(phoneNumber)
      if (!normalized) throw new Error('Enter a valid phone number including country code.')

      await userService.updateUserProfile({ phone_number: normalized, phone_verified: false })
      onVerified?.({ phoneNumber: normalized })
      onClose?.()
    } catch (err) {
      setError(err.message || 'Failed to save number')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal onClose={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">Add your mobile number</h2>
        <p className="text-sm text-gray-500 mb-4">We use this to keep your invoices safe and notify you about backups.</p>

        {error ? (
          <div className="mb-4 text-sm text-red-600">{error}</div>
        ) : null}

        <form onSubmit={handleSave} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mobile number</label>
            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="e.g. +91 98765 43210"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex items-center justify-end gap-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-700">Cancel</button>
            <button
              type="submit"
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white rounded-md disabled:opacity-50"
            >{saving ? 'Saving...' : 'Save number'}</button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default PhoneVerificationModal


